import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { DayModalDataService } from '../../day-modal-data.service';

import { ModalService } from '../../_modal';

@Component({
  selector: 'app-day-component',
  templateUrl: './day-component.component.html',
  styleUrls: ['./day-component.component.css']
})
export class DayComponentComponent implements OnInit {
  // @Input() currentSignId: number;
  @Input() dataTxt!: string;
  @Input() preDayIcon!: string;
  @Input() postDayIcon!: string;
  @Input() transferDate!: number;
  @Input() preSignColor!: string;
  @Input() postSignColor!: string;
  @Input() todayIs: number = 0; //all calendar days in the month. 
  @Input('currentSignId') activeSignId: any;
  @Input() TodayNumber : number | undefined; //todays current date
  @Input() currentMonthIsActive : boolean = false; //set true to show the today sun for the current month


  @Input() fullMoon: number | undefined; 
  @Input() fullMoon2: number | undefined; 
  @Input() newMoon: number | undefined; 
  @Input() newMoon2: number | undefined; 
  @Input() firstqmoon: number | undefined; 
  @Input() firstqmoon2: number | undefined; 
  @Input() lastqmoon: number | undefined; 
  @Input() lastqmoon2: number | undefined; 
  @Input() fullMoonName: string | undefined;
  @Input() fullMoonName2: string | undefined;
  // @Input('activeSignId') activeSignId: number;

  

  displayIcon: string = "";
  @Input() altMonth : string = 'na';


  //broadcast data to modal display
  @Output() setModalData: EventEmitter<any> = new EventEmitter();

  todaySun: boolean = false;
  // dayColor: string = '';
  cusp: boolean = false;
  cuspCat: string = ''
  preOrPostSignDay: string = '';
  backgroundType: any ;

  //Modal variables
  message!: string;
  modalDate!: number;

  moonSize: any = 30;



  constructor(private modalService: ModalService, private dayModalDataService: DayModalDataService) {
  // constructor() {

    // this.dataTxt = '';
    this.activeSignId = [];
    // this.todayIs 
    }

  ngOnInit(): void {
    this.customizeDay();
    // this.dayModalDataService.currentMessage.subscribe(message => this.message = message);
    this.dayModalDataService.currentModalDate.subscribe(modalDate => this.modalDate = modalDate);

  }
  ngOnChanges(changes: SimpleChanges){
    this.customizeDay();
  }

  customizeDay(){   

    this.altMonth === 'pre' || this.altMonth === 'post' ? this.formatAltMonths(this.altMonth) : this.formatCurrentDays();
    // if(this.altMonth === 'pre' || this.altMonth === 'post'){
    //   this.formatAltMonths(this.altMonth)
    // }

    // if(this.altMonth === 'na' && this.cusp === false){
    //   this.formatCurrentDays()
    // }
    
    // if(this.cusp === true){
    //   this.cuspCat='';
    //   this.cusp= false;
    //   this.altMonth = 'na';
    //   this.formatCurrentDays();
    // }

  }

  formatAltMonths(format: string){

    if(format === 'pre') {
      this.displayIcon = this.preDayIcon;
      // this.dayColor = this.preSignColor;
      this.getColor()

      }
    if(format === 'post') {
      this.displayIcon = this.postDayIcon;
      // this.dayColor = this.postSignColor;
      this.getColor()


    }
  }

  formatCurrentDays(){
    this.cusp = false;
    this.cuspCat = '';
    this.backgroundType = ''

    if (this.todayIs !== undefined && this.todayIs < this.transferDate){
      this.displayIcon = this.preDayIcon;
      // this.dayColor = this.preSignColor;
      // this.cusp = false;
      this.preOrPostSignDay = 'preSignDay';
      this.getColor()

    } else {
      this.displayIcon = this.postDayIcon; 
      // this.dayColor = this.preSignColor;
      // this.cusp = false;
      this.preOrPostSignDay = 'postSignDay';
      this.getColor()


    }

    if(this.transferDate-3 <= this.todayIs  && this.transferDate+3 >=this.todayIs) {
      
      this.formatCuspDay();
      

    }
   //Render Today Sun
   this.altMonth === 'na' && this.todayIs === this.TodayNumber && this.currentMonthIsActive === true ? this.todaySun = true : this.todaySun = false;
  
  }

  formatCuspDay(){

    // this.altMonth = 'cusp';
    this.displayIcon = this.preDayIcon + this.postDayIcon;
    
     // //get which cusp day to render the proper color transition
     this.todayIs - this.transferDate === -1 ? this.cuspCat = 'cusp-pre1' : null;
     this.todayIs - this.transferDate === -2 ? this.cuspCat = 'cusp-pre2' : null;
     this.todayIs - this.transferDate === -3 ? this.cuspCat = 'cusp-pre3' : null;
 
     this.todayIs === this.transferDate ? this.cuspCat ='cusp-0' : null;

     this.todayIs - this.transferDate === 1 ? this.cuspCat = 'cusp-post1' : null;
     this.todayIs - this.transferDate === 2 ? this.cuspCat = 'cusp-post2' : null;
     this.todayIs - this.transferDate === 3 ? this.cuspCat = 'cusp-post3' : null;
     this.cusp = true;

     this.getColor();


    // this.todayIs - this.transferDate === -1 ? console.log('todayIs - transferDate =1 -cusp-pre1', this.transferDate, this.todayIs ) : null;
    // this.todayIs - this.transferDate === -2 ? console.log('todayIs - transferDate =2 -cusp-pre2', this.transferDate, this.todayIs ) : null;
    // this.todayIs - this.transferDate === -3 ? console.log('todayIs - transferDate =3 -cusp-pre3', this.transferDate, this.todayIs ) : null;
 
    //this.todayIs === this.transferDate ? console.log('todayIs = transferDate cusp-0', this.transferDate, this.todayIs ) : null;

    // this.todayIs - this.transferDate === 1 ? console.log('todayIs - transferDate =1 cusp-post1', this.transferDate, this.todayIs ) : null;
    // this.todayIs - this.transferDate === 2 ? console.log('todayIs - transferDate =2 cusp-post2', this.transferDate, this.todayIs ) : null;
    // this.todayIs - this.transferDate === 3 ? console.log('todayIs - transferDate =3 cusp-post3', this.transferDate, this.todayIs ) : null;


  };


  //All color types translations
  getColor(): string {

    let dayColorIs;
    if(this.altMonth === 'pre' || this.altMonth === 'post') {
      // dayColorIs = this.altMonth;
      dayColorIs = 'none set';
    }

    if(this.altMonth === 'na' && this.cusp === false) {
      // preOrPostSignDay = 'preSignDay'
      // dayColorIs = this.preOrPostSignDay;
      dayColorIs = 'none set';
    }

    if(this.altMonth === 'na' && this.cusp === true) {
      dayColorIs = this.cuspCat;
    }


    // this.altMonth
    // //default cusp values (when not a cusp day)
    // this.cusp === false;
    // this.cuspCat === '';


    switch (dayColorIs) {

      case 'pre':
        this.backgroundType = {'background-color' : 'rgba('  + this.preSignColor + ', 1)' };
      return this.backgroundType;

      case 'post':
      this.backgroundType ={ 'background-color' : 'rgba(' + this.postSignColor + ', 1)'};
      return this.backgroundType;

      case 'postSignDay':
      this.backgroundType ={ 'background-color' : 'rgba(' + this.postSignColor + ', 0.7)'};
      return this.backgroundType;

      case 'preSignDay':
      this.backgroundType ={ 'background-color' : 'rgba(' + this.preSignColor + ', 0.7)'};
      return this.backgroundType;

      case 'cusp-pre3':
      this.backgroundType ={ 'background-color' : 'rgba(' + this.postSignColor + ', 0.1)'};
      return this.backgroundType;

      case 'cusp-pre2':
      this.backgroundType ={ 'background-color' : 'rgba(' + this.postSignColor + ', 0.2)'};
      return this.backgroundType;

      case 'cusp-pre1':
      this.backgroundType ={ 'background-color' : 'rgba(' + this.postSignColor + ', 0.3)'};
      return this.backgroundType;

      case 'cusp-0':
      // this.backgroundType ={ 'background' : 'conic-gradient(at 150%, rgba(' + this.postSignColor + ', 1), rgba(' + this.preSignColor + ', 1) '};
      this.backgroundType ={ 'background-color' : 'rgba(' + this.preSignColor + ', 0.4)'};
      return this.backgroundType;

      case 'cusp-post1':
      this.backgroundType ={ 'background-color' : 'rgba(' + this.preSignColor + ', 0.3)'};
      return this.backgroundType;

      case 'cusp-post2':   
      this.backgroundType ={ 'background-color' : 'rgba(' + this.preSignColor + ', 0.2)'};
      return this.backgroundType;

      case 'cusp-post3':
      this.backgroundType ={ 'background-color' : 'rgba(' + this.preSignColor + ', 0.1)'};
      return this.backgroundType;

      default:
        this.backgroundType = {'background-color' : 'unset'};
        return this.backgroundType;
    }
  }


  
  openModal(id: string) {
    
    // this.modalService.modalData(this.todayIs);
    // this.modalDate = this.todayIs;

    // this.dayModalDataService.changeMessage('Description text here')
    
    //send selected date to modal
    // this.dayModalDataService.changeDate(this.todayIs)
    // console.log('sent', this.todayIs)

    let dayDetails ={
      todayIs:this.todayIs,
      showTodaySun: this.todayIs == this.TodayNumber ? true : false ,
      fullmoonName: this.todayIs ==this.fullMoon ? this.fullMoonName : false,
      fullmoonName2: this.todayIs ==this.fullMoon2 ? this.fullMoonName2 : false,
      TodayNumber: this.TodayNumber,
      signIcon: this.displayIcon,

      fullMoon:this.todayIs ==this.fullMoon ? true : false, 
      fullMoon2:this.todayIs ==this.fullMoon2 ? true : false, 
      // fullMoon2: true, 
      newMoon:this.todayIs ==this.newMoon ? true : false, 
      newMoon2:this.todayIs ==this.newMoon2 ? true : false, 
      // newMoon2:true, 
      firstqmoon:this.todayIs ==this.firstqmoon ? true : false, 
      firstqmoon2:this.todayIs ==this.firstqmoon2 ? true : false, 
      lastqmoon:this.todayIs ==this.lastqmoon ? true : false, 
      lastqmoon2:this.todayIs ==this.lastqmoon2 ? true : false

    } 

    this.todayIs === 0 ? null : (this.modalService.open(id), this.setModalData.emit(dayDetails));
    //broadcast a request to parent component- to generate the selected date data and send it to the modal.
    
    // console.log('moon name check', this.fullMoonName, this.fullMoon, this.TodayNumber)
    // console.log('todayIs check', this.todayIs);

    
  }

  closeModal(id: string) {
      this.modalService.close(id);
  }
  


}